import http from "../utils/http"

/**
 * 提交商家入驻申请
 * @param {object} params 入驻申请信息
 */
export function submitShopApply(params) {
    return http({
        url: "/api/warehouse/merchantAudit",
        data: params,
        forceLogin: true
    })
}
